<template>
  <div class="no-header-layout unselectable">
    <div class="bs-b" v-if="isDesktop">
      <DesktopHeader
        v-bind:nav-state="navState"
      />

      <slot name="desktop-subheader"></slot>
    </div>

    <div class="page-content">
      <slot name="layout-body"></slot>
    </div>

    <slot name="modal-area"></slot>
  </div>
</template>

<script>
  import desktop from '@/mixins/desktop';

  export default {
    name: 'no-header-layout',

    mixins: [
      desktop,
    ],

    props: {
      navState: {
        type: String,
        default: null,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// NoHeaderLayout.vue?fd596758